export const FAQs = [
  {
    question: 'How much do rewards cost?',
    answer:
      'You’ll pay face value for any rewards that employees redeem in our catalog. For example, a $25 Visa gift card will cost you $25. This cost is billed separate from your subscription. You’ll never pay for points or allowances that go unused.',
  },
  {
    question: 'What kind of adoption can I expect for my company?',
    answer:
      'Adoption can vary by size and industry but typically our clients see over 80% adoption across their organizations each month and that number very often exceeds 90-95%.',
  },
  {
    question: 'How does PerksBar pricing work?',
    answer:
      'Pricing depends on the number of employees, product chosen, and service tier. All tiers are billed on a monthly basis.',
  },
  {
    question: 'Is there a set up fee?',
    answer:
      "There's no setup fee. Our aim is to make your experience with PerksBar as risk-free and enjoyable as possible, and this deposit is just a simple way to ensure that we can provide you with top-notch service from day one.",
  },
  {
    question: 'What’s the minimum number of users?',
    answer:
      'There is no minimum number of users. Subscriptions are on a per-person basis. However, having at least two is better.',
  },
  {
    question: 'Can my plan scale to fit company growth?',
    answer: 'Absolutely. You have the flexibility to upgrade your plan as your company grows.',
  },
  {
    question: 'Is PerksBar secure?',
    answer:
      'At PerksBar, we take data privacy and security very seriously. We are fully committed to maintaining the highest standards of data protection. We are actively working towards obtaining these certifications to further enhance our security measures and ensure the utmost privacy for your data.',
  },
];

export default FAQs;
